export default __webpack_public_path__ + "static/evidence-based-27a5c9e6e6bc2d464b0b22a1c728cd72.svg";